<div class="container">
	<div class="table-wrapper">
		<table class="table">
			<thead>
				<tr>
					<th></th>
					<th class="" i18n="@@products.product_name">Name</th>
					<th class="" i18n="@@products.product_name">Name Arabic</th>
					<th i18n="@@products.id">ID</th>
					<th i18n="@@products.product_category">Category</th>
					<th i18n="@@products.available_qty">Available Qty</th>
					<th i18n="@@products.preparation_time">Preparation Time</th>
					<th i18n="@@products.price">Price</th>
					<th i18n="@@products.discount">Discount</th>
					<th i18n="@@products.final_price">Final Price</th>
					<th i18n="@@ts.active">Active</th>
					<th i18n="@@ts.active">In Stock</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr class="orders_item" *ngFor="let row of myProducts | paginate: paginator; index as i" [class.disabled]="!row?.active">                    
					<td class="">
                        <div class="custom-checkbox">
							<input [class.disabled]="!row?.active" class="styled-checkbox select-item orders_inputAll" id="product-styled-checkbox-{{i}}" type="checkbox" (click)="toggleSelect(row[selectKey], row)" [checked]="selected.includes(row[selectKey])">
                            <svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"/>
                            </svg>
                            <svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"/>
                                <path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                    </td>
					<td class="">
						<div class="product_name_wrap">
							<img appLazyLoad="{{ row.product_image }}" loading="lazy" alt="{{ row.name | titlecase }}"> {{ row.name | titlecase }}
						</div>
					</td>
					<td class="">
						<div class="product_name_wrap">
							{{ row.name_ar || '-' }}
						</div>
					</td>
					<td><span class="underline-secondary order_id">#{{ row.product_number }}</span></td>
					<td>
						<span class="category_food">
							{{ row.category | titlecase }}
							<span *ngIf="row?.category_ar">
								 / {{ row.category_ar }}
							</span>
						</span>
					</td>
					<td>
						<ng-container *ngIf="editingCell[row.uuid + '_quantity']; else quantityView">
						<input
							type="number"
							[value]="row.quantity"
							(blur)="stopEdit(row.uuid, 'quantity', $event.target.valueAsNumber)"
							autofocus
						/>
						</ng-container>
						<ng-template #quantityView>
							{{ row.quantity }}
							<svg role="button" [class.disabled]="!row?.active" (click)="startEdit(row.uuid, 'quantity')" _ngcontent-kfo-c284="" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" class="edit_product"><path _ngcontent-kfo-c284="" d="M15.0002 8.33326L11.6669 4.99993M2.0835 17.9166L4.9038 17.6032C5.24838 17.5649 5.42067 17.5458 5.5817 17.4937C5.72457 17.4474 5.86054 17.3821 5.9859 17.2994C6.12721 17.2062 6.24978 17.0836 6.49493 16.8385L17.5002 5.83326C18.4207 4.91279 18.4207 3.4204 17.5002 2.49993C16.5797 1.57945 15.0873 1.57945 14.1669 2.49992L3.1616 13.5052C2.91645 13.7503 2.79388 13.8729 2.70069 14.0142C2.61802 14.1396 2.55268 14.2755 2.50642 14.4184C2.45429 14.5794 2.43515 14.7517 2.39686 15.0963L2.0835 17.9166Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
						</ng-template>
					</td>
					<td>{{ row.preparation_time ? row.preparation_time + ' mins' : '-' }}</td>
					<td>
						<ng-container *ngIf="editingCell[row.uuid + '_price']; else priceView">
							<input
								type="number"
								[value]="row.price"
								(blur)="stopEdit(row.uuid, 'price', $event.target.valueAsNumber)"
								autofocus
							/>
						</ng-container>
						<ng-template #priceView>
							<span class="sar-cur" [innerHtml]="basicInfo?.currency_symbol"></span>
							{{ row.price }}
							<svg role="button" [class.disabled]="!row?.active" (click)="startEdit(row.uuid, 'price')" _ngcontent-kfo-c284="" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" class="edit_product"><path _ngcontent-kfo-c284="" d="M15.0002 8.33326L11.6669 4.99993M2.0835 17.9166L4.9038 17.6032C5.24838 17.5649 5.42067 17.5458 5.5817 17.4937C5.72457 17.4474 5.86054 17.3821 5.9859 17.2994C6.12721 17.2062 6.24978 17.0836 6.49493 16.8385L17.5002 5.83326C18.4207 4.91279 18.4207 3.4204 17.5002 2.49993C16.5797 1.57945 15.0873 1.57945 14.1669 2.49992L3.1616 13.5052C2.91645 13.7503 2.79388 13.8729 2.70069 14.0142C2.61802 14.1396 2.55268 14.2755 2.50642 14.4184C2.45429 14.5794 2.43515 14.7517 2.39686 15.0963L2.0835 17.9166Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
						</ng-template>
					</td>
					<td>
						<ng-container *ngIf="row.discount_amount; else noDiscount">
							<span class="sar-cur" [innerHtml]="basicInfo?.currency_symbol"></span> {{ row.discount_amount }}
						</ng-container>
						<ng-template #noDiscount>
							<span>-</span>
						</ng-template>
					</td>
					<td class="order_total"><span class="sar-cur" [innerHtml]="basicInfo?.currency_symbol"></span> {{ row.net_price }}</td>
					<td>
						<div class="new-create-switch">
							<div class="switch-wrapper">
								<div class="switch">
									<input type="checkbox" id="auto-renew" name="auto-renew" [checked]="row.active" (change)="showHideProduct(row, 'active', 'status-update')">
									<span class="slider round"></span>
								</div>
							</div>
						</div>
					</td>
					<td>
						<div class="new-create-switch">
							<div class="switch-wrapper">
								<div class="switch">
									<input type="checkbox" id="auto-renew" name="auto-renew" [checked]="row.in_stock" (change)="showHideProduct(row, 'in_stock', 'stock-status')" >
									<span class="slider round"></span>
								</div>
							</div>
						</div>
					</td>
					<td class="text-center">
						<div class="d-flex flex-row gap-2 align-center justify-content-end">
							<svg (click)="editProduct(row)" [class.disabled]="!row?.active" class="edit_product" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
								<path d="M15.0002 8.33326L11.6669 4.99993M2.0835 17.9166L4.9038 17.6032C5.24838 17.5649 5.42067 17.5458 5.5817 17.4937C5.72457 17.4474 5.86054 17.3821 5.9859 17.2994C6.12721 17.2062 6.24978 17.0836 6.49493 16.8385L17.5002 5.83326C18.4207 4.91279 18.4207 3.4204 17.5002 2.49993C16.5797 1.57945 15.0873 1.57945 14.1669 2.49992L3.1616 13.5052C2.91645 13.7503 2.79388 13.8729 2.70069 14.0142C2.61802 14.1396 2.55268 14.2755 2.50642 14.4184C2.45429 14.5794 2.43515 14.7517 2.39686 15.0963L2.0835 17.9166Z" stroke="#646464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
							<svg (click)="onDelete.emit(row)" [class.disabled]="!row?.active" class="delete_product" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
								<path d="M13.3333 4.99984V4.33317C13.3333 3.39975 13.3333 2.93304 13.1517 2.57652C12.9919 2.26292 12.7369 2.00795 12.4233 1.84816C12.0668 1.6665 11.6001 1.6665 10.6667 1.6665H9.33333C8.39991 1.6665 7.9332 1.6665 7.57668 1.84816C7.26308 2.00795 7.00811 2.26292 6.84832 2.57652C6.66667 2.93304 6.66667 3.39975 6.66667 4.33317V4.99984M2.5 4.99984H17.5M15.8333 4.99984V14.3332C15.8333 15.7333 15.8333 16.4334 15.5608 16.9681C15.3212 17.4386 14.9387 17.821 14.4683 18.0607C13.9335 18.3332 13.2335 18.3332 11.8333 18.3332H8.16667C6.76654 18.3332 6.06647 18.3332 5.53169 18.0607C5.06129 17.821 4.67883 17.4386 4.43915 16.9681C4.16667 16.4334 4.16667 15.7333 4.16667 14.3332V4.99984" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>